/* ==========================================================================
   Midwest Ponds 2026 UI: announcement, sticky header, mega menu, predictive
   search, drawers, AJAX cart (Section Rendering API), quick add, add-ons,
   expiry dates, footer accordions. Vanilla JS, no dependencies.
   Exposes window.IvpTheme (cart, openDrawer, closeDrawer, toast, formatMoney).
   ========================================================================== */
(function () {
  'use strict';

  var d = document;
  var M = (window.IvpTheme = window.IvpTheme || {});
  var routes = Object.assign({
    root: '/', cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change',
    cart_update: '/cart/update', search: '/search', predictive_search: '/search/suggest'
  }, M.routes || {});
  var CART_SECTION = 'ivp-cart-drawer';
  var CART_DRAWER_ID = 'IvpCartDrawer';
  var desktopMq = window.matchMedia('(min-width: 1100px)');

  function qs(sel, el) { return (el || d).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || d).querySelectorAll(sel)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dispatch(name, detail) { d.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  M.qs = qs; M.qsa = qsa; M.esc = esc;

  /* ---------- Money ---------- */
  M.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || M.moneyFormat || '${{amount}}';
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  M.toast = function (msg) {
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'ivp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      d.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4500);
  };

  /* ---------- Overlays + scroll lock ---------- */
  var overlays = {};
  function overlay(kind) {
    if (overlays[kind]) return overlays[kind];
    var el = d.createElement('div');
    el.className = 'ivp-overlay ivp-overlay--' + kind + (kind === 'drawer' ? ' ivp-overlay--top' : '');
    el.setAttribute('aria-hidden', 'true');
    d.body.appendChild(el);
    overlays[kind] = el;
    return el;
  }
  var locks = 0;
  function lock() { if (locks++ === 0) d.documentElement.classList.add('ivp-lock'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) d.documentElement.classList.remove('ivp-lock'); }
  M.lock = lock; M.unlock = unlock;

  function focusables(el) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null || n === d.activeElement; });
  }

  /* ==========================================================================
     Expiry: data-ivp-until-ts="<epoch seconds>" (computed in Liquid in the shop's
     time zone) or data-ivp-until="YYYY-MM-DD" (end of that day, Sydney time).
     Liquid hides expired items too; this catches cached pages (lesson C8).
     ========================================================================== */
  function initExpiry() {
    var now = Date.now();
    qsa('[data-ivp-until-ts]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-ivp-until-ts'), 10) * 1000;
      if (end && now > end) el.remove();
    });
    qsa('[data-ivp-until]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-ivp-until') + 'T23:59:59+10:00');
      if (end && now > end) el.remove();
    });
  }

  /* ==========================================================================
     Announcement bar
     ========================================================================== */
  function initAnnouncement() {
    var bar = qs('[data-ivp-announce]');
    if (!bar) return;
    var slides = qsa('[data-ivp-slide]', bar);
    if (!slides.length) { bar.remove(); return; }
    if (!qs('.is-active', bar)) slides[0].classList.add('is-active');
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = false; }); });
    setInterval(function () {
      if (paused || d.hidden) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, (parseInt(bar.getAttribute('data-interval'), 10) || 6) * 1000);
  }

  /* ==========================================================================
     Header: sticky + hide on scroll down, show on scroll up
     ========================================================================== */
  var headerWrap = null;
  var closeMega = function () {};
  var closePredictive = function () {};

  function headerBottom() {
    var h = qs('[data-ivp-header]');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }

  function initHeader() {
    var header = qs('[data-ivp-header]');
    if (!header) return;
    headerWrap = header.closest('.shopify-section') || header;
    var lastY = window.scrollY, ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY;
      headerWrap.classList.toggle('is-scrolled', y > 10);
      var busy = d.documentElement.classList.contains('ivp-lock') || qs('.ivp-nav__item.is-open') || headerWrap.classList.contains('is-searching');
      if (!busy && y > 240 && y > lastY + 4) headerWrap.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 240) headerWrap.classList.remove('is-hidden');
      lastY = y;
      d.documentElement.style.setProperty('--ivp-header-bottom', headerBottom() + 'px');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ==========================================================================
     Mega menu (hover intent on desktop, first tap opens on touch, keyboard)
     ========================================================================== */
  function initMega() {
    var items = qsa('[data-ivp-mega-item]');
    if (!items.length) return;
    var ov = overlay('mega');
    var openItem = null, openTimer, closeTimer, lastPointer = 'mouse';

    function setExpanded(item, state) {
      var t = qs('[data-ivp-mega-trigger]', item);
      if (t) t.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
    function open(item) {
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) { openItem.classList.remove('is-open'); setExpanded(openItem, false); }
      closePredictive();
      item.classList.add('is-open');
      setExpanded(item, true);
      M.loadImages(item);
      openItem = item;
      ov.style.top = headerBottom() + 'px';
      ov.classList.add('is-visible');
    }
    function close() {
      clearTimeout(openTimer);
      if (!openItem) return;
      openItem.classList.remove('is-open');
      setExpanded(openItem, false);
      openItem = null;
      ov.classList.remove('is-visible');
    }
    closeMega = close;

    d.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        M.loadImages(item);
        if (!desktopMq.matches || lastPointer === 'touch') return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 110);
      });
      item.addEventListener('mouseleave', function () {
        if (lastPointer === 'touch') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(close, 220);
      });
      var trigger = qs('[data-ivp-mega-trigger]', item);
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          // Touch (or keyboard Enter): first activation opens the panel, second follows the link.
          if ((lastPointer === 'touch' || e.detail === 0) && openItem !== item) { e.preventDefault(); open(item); }
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === ' ') {
            e.preventDefault();
            open(item);
            var first = focusables(qs('[data-ivp-mega]', item))[0];
            if (first) first.focus();
          }
        });
      }
      item.addEventListener('focusout', function (e) {
        if (openItem === item && e.relatedTarget && !item.contains(e.relatedTarget)) close();
      });
    });

    // Preview panes: hovering or focusing a sub-category shows its pane
    qsa('[data-ivp-mega]').forEach(function (panel) {
      var items = qsa('[data-ivp-pane]', panel), panes = qsa('[data-ivp-pane-for]', panel);
      function show(i) {
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-ivp-pane') === i); });
        panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ivp-pane-for') === i); });
      }
      items.forEach(function (it) {
        it.addEventListener('mouseenter', function () { show(it.getAttribute('data-ivp-pane')); });
        it.addEventListener('focus', function () { show(it.getAttribute('data-ivp-pane')); });
      });
    });
    ov.addEventListener('click', close);
    ov.addEventListener('mouseenter', function () { if (lastPointer !== 'touch') { clearTimeout(closeTimer); closeTimer = setTimeout(close, 120); } });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var t = qs('[data-ivp-mega-trigger]', openItem);
      close();
      if (t) t.focus();
    });
    d.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(); });
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', close);
  }

  /* ==========================================================================
     Predictive search (inline dropdown; full height under the header on phones)
     ========================================================================== */
  function initSearch() {
    qsa('[data-ivp-search]').forEach(function (form) {
      var input = qs('[data-ivp-search-input]', form);
      var panel = qs('[data-ivp-predictive]', form);
      var clear = qs('[data-ivp-search-clear]', form);
      if (!input || !panel) return;
      var popular = (panel.getAttribute('data-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var ctrl = null, timer = null, cache = {};

      function show() {
        closeMega();
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        if (headerWrap && form.closest('[data-ivp-header]')) {
          headerWrap.classList.add('is-searching');
          d.documentElement.style.setProperty('--ivp-search-top', (form.getBoundingClientRect().bottom + 8) + 'px');
          if (!desktopMq.matches) lock();
        }
      }
      function hide() {
        if (panel.hidden) return;
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        if (headerWrap && headerWrap.classList.contains('is-searching')) {
          headerWrap.classList.remove('is-searching');
          if (!desktopMq.matches) unlock();
        }
      }
      if (form.closest('[data-ivp-header]')) closePredictive = hide;

      function renderPopular() {
        panel.classList.remove('has-products');
        if (!popular.length) { hide(); return; }
        panel.innerHTML = '<div class="ivp-predictive__group"><p class="ivp-predictive__title">Popular searches</p><div class="ivp-predictive__links">' +
          popular.map(function (t) { return '<a class="ivp-chip" href="' + esc(routes.search + '?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last') + '">' + esc(t) + '</a>'; }).join('') +
          '</div></div>';
        show();
      }

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2) fetchResults(input.value.trim()); else renderPopular();
      });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (clear) clear.hidden = !input.value;
        if (q.length < 2) { renderPopular(); return; }
        timer = setTimeout(function () { fetchResults(q); }, 160);
      });
      if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; input.focus(); renderPopular(); });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { hide(); input.blur(); }
        if (e.key === 'ArrowDown') { var first = qs('a', panel); if (first) { e.preventDefault(); first.focus(); } }
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { hide(); input.focus(); return; }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = qsa('a', panel), idx = links.indexOf(d.activeElement);
        if (idx < 0) return;
        e.preventDefault();
        if (e.key === 'ArrowUp' && idx === 0) { input.focus(); return; }
        var next = links[idx + (e.key === 'ArrowDown' ? 1 : -1)];
        if (next) next.focus();
      });
      d.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
      form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) hide(); });

      function fetchResults(q) {
        if (cache[q]) { render(q, cache[q]); return; }
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        if (panel.hidden || !qs('.ivp-predictive__group', panel)) { panel.innerHTML = '<p class="ivp-predictive__loading">Searching…</p>'; show(); }
        var url = routes.predictive_search + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { cache[q] = (data.resources && data.resources.results) || {}; if (input.value.trim() === q) render(q, cache[q]); })
          .catch(function (err) { if (!err || err.name !== 'AbortError') panel.innerHTML = ''; });
      }

      // A product without photos gets the greyed-logo placeholder (same look as snippets/ivp-placeholder.liquid)
      function placeholder() {
        return M.logo ? '<span class="ivp-ph ivp-ph--s ivp-predictive__ph" aria-hidden="true"><img class="ivp-ph__logo" src="' + esc(M.logo) + '" alt="" loading="lazy"></span>' : '';
      }
      function item(url, title, meta, img, isProduct) {
        return '<li><a class="ivp-predictive__item" role="option" href="' + esc(url) + '">' +
          (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64" loading="lazy">' : (isProduct ? placeholder() : '')) +
          '<span><span class="ivp-predictive__name">' + esc(title) + '</span>' + (meta ? '<span class="ivp-predictive__meta">' + meta + '</span>' : '') + '</span></a></li>';
      }

      function render(q, res) {
        var products = res.products || [];
        var collections = (res.collections || []).slice(0, 4);
        var pages = (res.pages || []).concat(res.articles || []).slice(0, 4);
        var allUrl = routes.search + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        if (!products.length && !collections.length && !pages.length) {
          panel.classList.remove('has-products');
          panel.innerHTML = '<p class="ivp-predictive__empty">No results for “' + esc(q) + '”. Try a product type, such as jeans, jacket or race suit, or message us and we will help you find it.</p>';
          if (popular.length) panel.innerHTML += '<div class="ivp-predictive__group"><div class="ivp-predictive__links">' + popular.map(function (t) { return '<a class="ivp-chip" href="' + esc(routes.search + '?q=' + encodeURIComponent(t)) + '">' + esc(t) + '</a>'; }).join('') + '</div></div>';
          show();
          return;
        }
        var html = '';
        if (collections.length) {
          html += '<div class="ivp-predictive__group ivp-predictive__group--side"><p class="ivp-predictive__title">Categories</p><div class="ivp-predictive__links">' +
            collections.map(function (c) { return '<a class="ivp-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
        }
        if (products.length) {
          html += '<div class="ivp-predictive__group ivp-predictive__group--main"><p class="ivp-predictive__title">Products</p><ul class="ivp-predictive__list" role="list">';
          products.forEach(function (p) {
            var min = p.price_min || p.price, max = p.price_max || p.price;
            var price = M.formatMoney(Math.round(parseFloat(min) * 100));
            if (max && min && max !== min) price = 'From ' + price;
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            var meta = (p.available === false && parseFloat(max || 0) === 0) ? 'Coming soon' : esc(price) + (p.available === false ? ' · Sold out' : '');
            html += item(p.url, p.title, meta, img, true);
          });
          html += '</ul></div>';
        }
        if (pages.length) {
          html += '<div class="ivp-predictive__group ivp-predictive__group--side"><p class="ivp-predictive__title">Guides & pages</p><ul class="ivp-predictive__list" role="list">';
          pages.forEach(function (pg) { html += item(pg.url, pg.title, '', pg.image || (pg.featured_image && pg.featured_image.url)); });
          html += '</ul></div>';
        }
        html += '<a class="ivp-predictive__all" href="' + esc(allUrl) + '">See all results for “' + esc(q) + '” <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg></a>';
        panel.innerHTML = html;
        panel.classList.toggle('has-products', products.length > 0);
        show();
      }
    });
  }

  /* ==========================================================================
     Drawers (menu, cart, filters)
     ========================================================================== */
  var currentDrawer = null, returnFocus = null;

  function openDrawer(id, opener) {
    var dr = d.getElementById(id);
    if (!dr) return false;
    if (currentDrawer && currentDrawer !== dr) closeDrawer(true);
    closeMega(); closePredictive();
    if (currentDrawer !== dr) { returnFocus = opener || d.activeElement; lock(); }
    currentDrawer = dr;
    dr.classList.add('is-open');
    overlay('drawer').classList.add('is-visible');
    qsa('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var target = qs('[data-ivp-autofocus]', dr) || qs('[data-ivp-drawer-close]', dr) || dr;
      target.focus({ preventScroll: true });
    }, 80);
    dispatch('ivp:drawer:open', { id: id });
    return true;
  }
  function closeDrawer(silent) {
    if (!currentDrawer) return;
    var dr = currentDrawer;
    currentDrawer = null;
    dr.classList.remove('is-open');
    qsa('[aria-controls="' + dr.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    unlock();
    if (!silent) {
      overlay('drawer').classList.remove('is-visible');
      if (returnFocus && returnFocus.focus) returnFocus.focus({ preventScroll: true });
    }
    dispatch('ivp:drawer:close', { id: dr.id });
  }
  M.openDrawer = openDrawer;
  M.closeDrawer = closeDrawer;

  function parkDrawers() {
    // Drawers inside the sticky header section would share its stacking context and sit under
    // the overlay, so every drawer lives directly under <body>.
    qsa('[data-ivp-drawer]').forEach(function (dr) {
      if (dr.parentNode === d.body) return;
      var stale = d.body.querySelector(':scope > #' + dr.id);
      if (stale && stale !== dr) stale.remove();
      d.body.appendChild(dr);
    });
  }
  M.parkDrawers = parkDrawers;

  function initDrawers() {
    parkDrawers();
    overlay('drawer').addEventListener('click', function () { closeDrawer(); });
    d.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ivp-drawer-open]');
      if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-ivp-drawer-open'), opener); return; }
      var closer = e.target.closest('[data-ivp-drawer-close]');
      if (closer && currentDrawer && currentDrawer.contains(closer)) { e.preventDefault(); closeDrawer(); }
    });
    d.addEventListener('keydown', function (e) {
      if (!currentDrawer) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(currentDrawer);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || d.activeElement === currentDrawer)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', function () {
      if (desktopMq.matches && currentDrawer && currentDrawer.id === 'IvpMenuDrawer') closeDrawer();
    });
  }

  /* ==========================================================================
     Cart (AJAX API + Section Rendering API)
     ========================================================================== */
  var Cart = (M.cart = {
    sections: function () {
      var ids = [];
      if (d.getElementById(CART_DRAWER_ID)) ids.push(CART_SECTION);
      qsa('[data-ivp-cart-page]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
      return ids;
    },
    request: function (url, body) {
      var ids = this.sections();
      if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    },
    add: function (items) {
      var self = this;
      return this.request(routes.cart_add, { items: items }).then(function (data) {
        self.render(data.sections, { added: (data.items || []).map(function (i) { return String(i.variant_id); }) });
        dispatch('ivp:cart:added', { items: data.items });
        return data;
      });
    },
    change: function (line, quantity) {
      var self = this;
      return this.request(routes.cart_change, { line: line, quantity: quantity }).then(function (data) {
        self.render(data.sections);
        dispatch('ivp:cart:changed', { cart: data });
        return data;
      });
    },
    note: function (note) {
      return fetch(routes.cart_update + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      });
    },
    refresh: function () {
      var self = this, ids = this.sections();
      if (!ids.length) return Promise.resolve();
      return fetch(window.location.pathname + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (map) { self.render(map); });
    },
    render: function (map, opts) {
      if (!map) return;
      opts = opts || {};
      Object.keys(map).forEach(function (id) {
        var html = map[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === CART_SECTION) {
          var fresh = qs('[data-ivp-cart-inner]', doc);
          var current = qs('#' + CART_DRAWER_ID + ' [data-ivp-cart-inner]');
          if (fresh && current) {
            var body = qs('.ivp-drawer__body', current);
            var scroll = body ? body.scrollTop : 0;
            current.replaceWith(fresh);
            var nb = qs('#' + CART_DRAWER_ID + ' .ivp-drawer__body');
            if (nb && !opts.added) nb.scrollTop = scroll;
          }
          var count = fresh ? parseInt(fresh.getAttribute('data-item-count'), 10) : NaN;
          if (!isNaN(count)) Cart.updateCount(count);
        } else {
          var page = qs('[data-ivp-cart-page][data-section-id="' + id + '"]');
          var next = qs('[data-ivp-cart-page]', doc);
          if (page && next) {
            if (page.getAttribute('data-state') === next.getAttribute('data-state')) {
              qsa('[data-ivp-cart-region]', next).forEach(function (region) {
                var name = region.getAttribute('data-ivp-cart-region');
                var cur = qs('[data-ivp-cart-region="' + name + '"]', page);
                if (cur) cur.replaceWith(region);
              });
            } else {
              page.replaceWith(next);
            }
            var c2 = parseInt(next.getAttribute('data-item-count'), 10);
            if (!isNaN(c2)) Cart.updateCount(c2);
          }
        }
      });
      if (opts.added && opts.added.length) {
        var notice = qs('#' + CART_DRAWER_ID + ' [data-ivp-cart-notice]');
        if (notice) notice.hidden = false;
        opts.added.forEach(function (vid) {
          qsa('[data-ivp-line][data-variant-id="' + vid + '"]').forEach(function (li) { li.classList.add('is-new'); });
        });
      }
      dispatch('ivp:cart:rendered');
    },
    updateCount: function (n) {
      qsa('[data-ivp-cart-count]').forEach(function (el) {
        var changed = el.textContent.trim() !== String(n);
        el.textContent = n;
        el.hidden = n === 0;
        if (changed && n > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
    }
  });

  function setLoading(btn, state) {
    if (!btn) return;
    btn.classList.toggle('is-loading', state);
    btn.setAttribute('aria-busy', state ? 'true' : 'false');
  }
  M.setLoading = setLoading;

  function openCart(opener) {
    if (qs('[data-ivp-cart-page]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return true; }
    return openDrawer(CART_DRAWER_ID, opener);
  }
  M.openCart = openCart;

  function initCart() {
    d.addEventListener('click', function (e) {
      var cartLink = e.target.closest('[data-ivp-cart-open]');
      if (cartLink && d.getElementById(CART_DRAWER_ID) && !qs('[data-ivp-cart-page]')) {
        e.preventDefault();
        openCart(cartLink);
        return;
      }

      // Quick add (cards, add-ons)
      var add = e.target.closest('[data-ivp-add]');
      if (add) {
        e.preventDefault();
        var id = parseInt(add.getAttribute('data-ivp-add'), 10);
        if (add.hasAttribute('data-ivp-add-from-select')) {
          var sel = qs('[data-ivp-variant-select]', add.parentNode);
          if (sel) id = parseInt(sel.value, 10);
        }
        var qty = parseInt(add.getAttribute('data-quantity'), 10) || 1;
        setLoading(add, true);
        Cart.add([{ id: id, quantity: qty }])
          .then(function () { openCart(add); })
          .catch(function (err) { M.toast(err.message); })
          .then(function () { setLoading(add, false); });
        return;
      }

      var qbtn = e.target.closest('[data-ivp-line-qty]');
      if (qbtn) { e.preventDefault(); changeLine(qbtn, parseInt(qbtn.getAttribute('data-ivp-line-qty'), 10)); return; }
      var rm = e.target.closest('[data-ivp-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm, 0); }
    });

    d.addEventListener('change', function (e) {
      var input = e.target.closest('[data-ivp-line-input]');
      if (input) { changeLine(input, Math.max(0, parseInt(input.value, 10) || 0)); return; }
      var note = e.target.closest('[data-ivp-cart-note]');
      if (note) Cart.note(note.value);
    });

    function changeLine(el, qty) {
      var line = el.closest('[data-ivp-line]');
      if (!line) return;
      line.classList.add('is-updating');
      Cart.change(parseInt(line.getAttribute('data-line'), 10), qty).catch(function (err) {
        line.classList.remove('is-updating');
        var msg = qs('[data-ivp-line-error]', line);
        if (msg) { msg.textContent = err.message; msg.hidden = false; } else M.toast(err.message);
      });
    }

    d.addEventListener('ivp:drawer:close', function (e) {
      if (e.detail.id !== CART_DRAWER_ID) return;
      var notice = qs('#' + CART_DRAWER_ID + ' [data-ivp-cart-notice]');
      if (notice) notice.hidden = true;
    });

    // Express checkout in the drawer: rendered from sections/ivp-cart-express.liquid only once the drawer is open
    // with items (and again after each re-render), then started with Shopify.PaymentButton.init(), which loads the
    // wallet script on demand. Pages where nobody opens the cart never download it.
    function loadExpress() {
      var dr = d.getElementById(CART_DRAWER_ID);
      var slot = dr && dr.classList.contains('is-open') && qs('[data-ivp-cart-express]', dr);
      // not shown at this width (setting "Tablets and desktop" on a phone): nothing to load
      if (!slot || slot.hasAttribute('data-state') || getComputedStyle(slot).display === 'none' && !slot.hidden) return;
      slot.setAttribute('data-state', 'loading');
      slot.hidden = false;
      fetch(window.location.pathname + '?section_id=ivp-cart-express')
        .then(function (r) { if (!r.ok) throw new Error('express ' + r.status); return r.text(); })
        .then(function (html) {
          var inner = qs('[data-ivp-express-inner]', new DOMParser().parseFromString(html, 'text/html'));
          if (!slot.isConnected) return;
          if (!inner) { slot.hidden = true; slot.setAttribute('data-state', 'none'); return; }
          slot.appendChild(inner);
          slot.setAttribute('data-state', 'ready');
          var pb = window.Shopify && window.Shopify.PaymentButton;
          if (pb && typeof pb.init === 'function') pb.init();
        })
        // a network hiccup: hide the empty row and try again the next time the drawer opens
        .catch(function () { if (slot.isConnected) { slot.hidden = true; slot.removeAttribute('data-state'); } });
    }
    d.addEventListener('ivp:drawer:open', function (e) { if (e.detail.id === CART_DRAWER_ID) loadExpress(); });
    d.addEventListener('ivp:cart:rendered', loadExpress);

    // Legacy Wokiee add-to-cart buttons (calculator pages) still update the drawer.
    if (window.jQuery && d.getElementById(CART_DRAWER_ID)) {
      window.jQuery(d).ajaxComplete(function (event, xhr, settings) {
        if (!settings || !/\/cart\/add/.test(settings.url || '') || xhr.status >= 400) return;
        Cart.refresh().then(function () { openCart(); });
      });
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
  }

  /* ==========================================================================
     Footer columns: open on desktop, accordions on phones
     ========================================================================== */
  function initFooter() {
    var cols = qsa('[data-ivp-footer-col]');
    if (!cols.length) return;
    var mq = window.matchMedia('(min-width: 900px)');
    function sync() { cols.forEach(function (c) { if (mq.matches) c.setAttribute('open', ''); else c.removeAttribute('open'); }); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }

  /* ==========================================================================
     Horizontal scrollers: prev/next buttons ([data-ivp-scroller])
     ========================================================================== */
  /* Arrow buttons work through one document-level listener, so sliders that are re-rendered later (the cart
     drawer's "Complete your kit") keep working. Mouse users can also drag any slider sideways. */
  var SLIDERS = '[data-ivp-track], .ivp-upsell__track, .ivp-cine__rail, .ivp-riders__list, .ivp-sg__tiles, .ivp-care__tiles';
  function scrollerTrack(wrap) {
    var tracks = qsa('[data-ivp-track]', wrap);
    return tracks.filter(function (t) { return t.offsetParent !== null; })[0] || tracks[0];
  }
  function scrollerSync(wrap) {
    var t = scrollerTrack(wrap);
    if (!t) return;
    var prev = qs('[data-ivp-prev]', wrap), next = qs('[data-ivp-next]', wrap);
    var over = t.scrollWidth - t.clientWidth > 8;
    var arrows = qs('.ivp-arrows', wrap);
    if (arrows) arrows.hidden = !over;
    if (prev) prev.disabled = t.scrollLeft < 8;
    if (next) next.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8;
  }
  function initScrollers() { qsa('[data-ivp-scroller]').forEach(scrollerSync); }
  d.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ivp-prev], [data-ivp-next]');
    if (btn) {
      var wrap = btn.closest('[data-ivp-scroller]'), t = wrap && scrollerTrack(wrap);
      if (!t) return;
      var c = t.firstElementChild;
      var step = c ? c.getBoundingClientRect().width + 12 : t.clientWidth * 0.8;
      var n = Math.max(1, Math.floor(t.clientWidth / step));
      t.scrollBy({ left: (btn.hasAttribute('data-ivp-prev') ? -1 : 1) * step * n, behavior: 'smooth' });
      return;
    }
    var tab = e.target.closest('[data-ivp-scroller] [role="tab"]');
    if (tab) setTimeout(function () { scrollerSync(tab.closest('[data-ivp-scroller]')); }, 30);
  });
  d.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wrap = t.closest('[data-ivp-scroller]');
    if (wrap) requestAnimationFrame(function () { scrollerSync(wrap); });
  }, true);
  window.addEventListener('resize', function () { initScrollers(); });

  /* Drag to scroll with a mouse (touch already swipes) */
  var drag = null;
  d.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var t = e.target.closest(SLIDERS);
    if (!t || t.scrollWidth - t.clientWidth < 8 || e.target.closest('input, select, textarea')) return;
    drag = { t: t, x: e.clientX, left: t.scrollLeft, moved: false };
  });
  d.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 6) return;
    if (!drag.moved) { drag.moved = true; drag.t.classList.add('is-dragging'); }
    drag.t.scrollLeft = drag.left - dx;
  });
  /* Where a released drag should settle: the next card edge in the drag direction (letting scroll-snap pick
     the nearest edge pulls a short drag back to where it started, so the drag looks broken). */
  function dragTarget(t, from) {
    var cur = t.scrollLeft, dir = cur - from, max = t.scrollWidth - t.clientWidth;
    if (Math.abs(dir) < 30) return from;
    var cs = getComputedStyle(t), pad = parseFloat(cs.scrollPaddingLeft) || 0;
    var base = t.getBoundingClientRect().left + t.clientLeft, target = null;
    for (var i = 0; i < t.children.length; i++) {
      var x = Math.round(cur + t.children[i].getBoundingClientRect().left - base - pad);
      if (dir > 0 && x > cur + 2) { target = x; break; }
      if (dir < 0 && x < cur - 2) target = x;
    }
    if (target === null) target = dir > 0 ? max : 0;
    return Math.max(0, Math.min(max, target));
  }
  function endDrag() {
    if (!drag) return;
    var t = drag.t, moved = drag.moved, from = drag.left;
    drag = null;
    if (!moved) return;
    var target = dragTarget(t, from);
    t.classList.remove('is-dragging');
    t.style.scrollSnapType = 'none';
    t.scrollTo({ left: target, behavior: 'smooth' });
    var done = function () { t.style.scrollSnapType = ''; t.removeEventListener('scrollend', done); };
    t.addEventListener('scrollend', done);
    setTimeout(done, 800);
    // a drag is not a click on the card underneath
    var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    t.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(function () { t.removeEventListener('click', stop, { capture: true }); }, 50);
  }
  d.addEventListener('pointerup', endDrag);
  d.addEventListener('pointercancel', endDrag);
  d.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest(SLIDERS)) e.preventDefault(); });
  d.addEventListener('ivp:cart:rendered', function () { initScrollers(); if (M.initSwipeBars) M.initSwipeBars(); });
  M.initScrollers = initScrollers;

  /* ---------- Slider progress bars: show that a row scrolls sideways (phones had no visible control) ---------- */
  function initSwipeBars() {
    qsa('.ivp-track, .ivp-upsell__track, .ivp-cine__rail, .ivp-riders__list, .ivp-sg__tiles, .ivp-care__tiles').forEach(function (el) {
      if (el._bar) { el._sync(); return; }
      var bar = d.createElement('div');
      bar.className = 'ivp-swipe-bar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      el.parentNode.insertBefore(bar, el.nextSibling);
      el._bar = bar;
      var thumb = bar.firstChild;
      function sync() {
        var over = el.scrollWidth - el.clientWidth;
        var shown = over > 8 && el.offsetParent !== null;
        bar.hidden = !shown;
        if (!shown) return;
        var ratio = el.clientWidth / el.scrollWidth;
        thumb.style.width = Math.max(12, ratio * 100) + '%';
        thumb.style.transform = 'translateX(' + ((el.scrollLeft / over) * ((1 - ratio) / ratio) * 100) + '%)';
      }
      el._sync = sync;
      el.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) sync(); }).observe(el);
      window.addEventListener('resize', sync);
      d.addEventListener('click', function (e) { if (e.target.closest('[role="tab"]')) setTimeout(sync, 60); });
      sync();
    });
  }
  M.initSwipeBars = initSwipeBars;

  /* ---------- Tabs ([data-ivp-tabs]) ---------- */
  function initTabs() {
    qsa('[data-ivp-tabs]').forEach(function (root) {
      var tabs = qsa('[role="tab"]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var p = d.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
        tab.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab);
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
            n.focus(); n.click();
          }
        });
      });
    });
  }

  /* ---------- Click-to-play video facades ([data-ivp-video]) ---------- */
  function initVideos() {
    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ivp-video-play]');
      if (!btn) return;
      var box = btn.closest('[data-ivp-video]');
      if (!box || box.classList.contains('is-playing')) return;
      var yt = box.getAttribute('data-youtube'), src = box.getAttribute('data-src');
      var el;
      if (yt) {
        el = d.createElement('iframe');
        el.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&playsinline=1';
        el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        el.allowFullscreen = true;
        el.title = btn.getAttribute('aria-label') || 'Video';
      } else {
        el = d.createElement('video');
        el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true;
      }
      box.appendChild(el);
      box.classList.add('is-playing');
      if (el.play) { var pr = el.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
  }

  /* ---------- Click-to-load embeds in merchant content (snippets/ivp-rte) ---------- */
  function initFrames() {
    qsa('iframe[data-ivp-frame][data-src]').forEach(function (fr) {
      if (fr.closest('.ivp-frame')) return;
      var src = fr.getAttribute('data-src');
      var yt = src.match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]{11})/);
      var isVideo = !!yt || /vimeo\.com/.test(src);
      var w = parseInt(fr.getAttribute('width'), 10) || 16, h = parseInt(fr.getAttribute('height'), 10) || 9;
      var box = d.createElement('div');
      box.className = 'ivp-frame ' + (isVideo ? 'ivp-frame--video' : 'ivp-frame--doc');
      box.style.aspectRatio = w + ' / ' + h;
      if (yt) box.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + yt[1] + '/hqdefault.jpg)';
      var btn = d.createElement('button');
      btn.type = 'button';
      btn.className = 'ivp-frame__btn';
      var label = isVideo ? 'Play video' : 'View document';
      btn.innerHTML = (isVideo
        ? '<svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'
        : '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14 3H6v18h12V7z"/><path d="M14 3v4h4M9 13h6M9 17h6"/></svg>') + '<span>' + label + '</span>';
      if (fr.title) btn.setAttribute('aria-label', label + ': ' + fr.title);
      fr.parentNode.insertBefore(box, fr);
      box.appendChild(fr);
      box.appendChild(btn);
      btn.addEventListener('click', function () {
        fr.src = isVideo ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1' : src;
        box.classList.add('is-loaded');
        btn.remove();
      });
    });
  }

  /* ---------- Deferred decorative images (snippets/ivp-lazy-img) ---------- */
  function loadImg(img) {
    var ss = img.getAttribute('data-ivp-srcset');
    if (!ss) return;
    img.srcset = ss;
    img.removeAttribute('data-ivp-srcset');
  }
  M.loadImages = function (root) {
    qsa('[data-ivp-srcset]', root).forEach(loadImg);
    qsa('img[data-ivp-src]', root).forEach(function (img) { img.src = img.getAttribute('data-ivp-src'); img.removeAttribute('data-ivp-src'); });
  };
  function initLazy() {
    var imgs = qsa('img[data-ivp-lazy="scroll"][data-ivp-srcset]');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(loadImg); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { loadImg(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '300px 300px' });
    imgs.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Reveal on scroll (subtle) ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = qsa('[data-ivp-reveal]');
    if (!els.length) return;
    d.documentElement.classList.add('ivp-reveal-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Legacy search autocomplete off for new forms (lesson S9) ---------- */
  function detachLegacySearch() {
    var $ = window.jQuery;
    if (!$) return;
    qsa('[data-ivp-search]').forEach(function (form) {
      $(form).find('input[name="q"]').off('keyup change');
      $(form).find('.search-results').remove();
    });
  }

  // Back to top: shows after about one screen of scrolling (user feedback: missing after the redesign)
  function initToTop() {
    var btn = qs('[data-ivp-totop]');
    if (!btn) return;
    var ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.2);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var main = qs('#MainContent');
      if (main) main.focus({ preventScroll: true });
    });
    update();
  }

  /* ---------- New-tab links get rel="noopener", also the ones apps add later (Judge.me's rating, medal and
     "Verified" links have no rel; SEO audit 20 Oct 2026, the crawl ran the page's scripts) ---------- */
  function initSafeLinks() {
    function fix(root) {
      var links = root.matches && root.matches('a[target="_blank"]') ? [root] : qsa('a[target="_blank"]', root);
      links.forEach(function (a) {
        if (!a.relList.contains('noopener') && !a.relList.contains('noreferrer')) a.relList.add('noopener');
      });
    }
    fix(d);
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n); });
      });
    }).observe(d.body, { childList: true, subtree: true });
  }

  /* ---------- Product cards: the hover image loads on the first real mouse hover (never on touch screens) ---------- */
  function initCardHover() {
    d.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('.ivp-card');
      if (!card) return;
      var img = card.querySelector('img.ivp-card__img2[data-ivp-hover-srcset]');
      if (!img) return;
      img.srcset = img.getAttribute('data-ivp-hover-srcset');
      img.removeAttribute('data-ivp-hover-srcset');
    }, { passive: true });
  }


  /* ---------- Hotspots ([data-ivp-spot]): tap/click toggles, hover shows on desktop ---------- */
  function initSpots() {
    var spots = qsa('[data-ivp-spot]');
    if (!spots.length) return;
    function closeAll(except) {
      spots.forEach(function (s) {
        if (s === except) return;
        s.classList.remove('is-open');
        var b = qs('.ivp-spot__dot', s); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    spots.forEach(function (s) {
      var btn = qs('.ivp-spot__dot', s);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        closeAll(s);
        s.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    d.addEventListener('click', function () { closeAll(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Hero video pause (WCAG 2.2.2) ---------- */
  function initHeroVideo() {
    qsa('[data-ivp-hero-pause]').forEach(function (btn) {
      var wrap = btn.parentNode;
      btn.addEventListener('click', function () {
        var vids = qsa('video', wrap), paused = btn.getAttribute('aria-pressed') === 'true';
        vids.forEach(function (v) { if (paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
        btn.setAttribute('aria-label', paused ? 'Pause video' : 'Play video');
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) btn.click();
    });
  }

  /* ---------- Card swatches: show that colour's photo ([data-ivp-swap]) ---------- */
  function initCardSwatches() {
    function swap(sw) {
      var card = sw.closest('.ivp-card'), img = card && qs('.ivp-card__img', card);
      if (!img) return;
      if (!img.hasAttribute('data-orig')) img.setAttribute('data-orig', img.currentSrc || img.src);
      img.removeAttribute('srcset');
      img.src = sw.getAttribute('data-ivp-swap');
      card.classList.add('is-swatched'); // the hover photo must not cover the colour just picked
      qsa('.ivp-card__swatch', card).forEach(function (o) { o.classList.toggle('is-active', o === sw); });
    }
    d.addEventListener('pointerover', function (e) { if (e.pointerType !== 'mouse') return; var sw = e.target.closest && e.target.closest('[data-ivp-swap]'); if (sw) swap(sw); }, { passive: true });
    d.addEventListener('click', function (e) { var sw = e.target.closest && e.target.closest('[data-ivp-swap]'); if (sw) { e.preventDefault(); swap(sw); } });
  }

  /* ---------- Lightbox: [data-ivp-lbx] links inside a [data-ivp-lbx-group] open the group's photos in one shared
     dialog with previous/next buttons, a counter, arrow keys and swipe (scroll-snap track); Esc, the close button
     or a click beside the photo closes it. The link's href is the large photo, so it still opens without JS.
     On the link: data-srcset, data-caption (optional). On the group: its name, and data-ivp-lbx-tone="light" for
     product shots on white (photos sit on dark). ---------- */
  function initLightbox() {
    if (!('showModal' in d.createElement('dialog'))) return; // old browsers follow the link to the photo
    var dlg, track, count, prev, next, items = [], index = 0, opener = null, raf = 0;
    function svg(p) { return '<svg class="ivp-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + p + '</svg>'; }
    function build() {
      dlg = d.createElement('dialog');
      dlg.className = 'ivp-lbx';
      dlg.innerHTML = '<div class="ivp-lbx__track"></div>' +
        '<p class="ivp-lbx__count" aria-live="polite"></p>' +
        '<button type="button" class="ivp-lbx__btn ivp-lbx__close" aria-label="Close" autofocus>' + svg('<path d="M6 6l12 12M18 6 6 18"/>') + '</button>' +
        '<button type="button" class="ivp-lbx__btn ivp-lbx__nav ivp-lbx__nav--prev" aria-label="Previous photo">' + svg('<path d="m15 6-6 6 6 6"/>') + '</button>' +
        '<button type="button" class="ivp-lbx__btn ivp-lbx__nav ivp-lbx__nav--next" aria-label="Next photo">' + svg('<path d="m9 6 6 6-6 6"/>') + '</button>';
      d.body.appendChild(dlg);
      track = qs('.ivp-lbx__track', dlg); count = qs('.ivp-lbx__count', dlg);
      prev = qs('.ivp-lbx__nav--prev', dlg); next = qs('.ivp-lbx__nav--next', dlg);
      prev.addEventListener('click', function () { go(index - 1); });
      next.addEventListener('click', function () { go(index + 1); });
      qs('.ivp-lbx__close', dlg).addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      // a click beside the photo closes; a click on the photo does not
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('ivp-lbx__slide')) dlg.close(); });
      dlg.addEventListener('close', function () {
        unlock();
        track.innerHTML = '';
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      });
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setIndex(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
    }
    function setIndex(i) {
      index = Math.max(0, Math.min(items.length - 1, i));
      count.innerHTML = '<span aria-hidden="true">' + (index + 1) + ' / ' + items.length + '</span><span class="ivp-visually-hidden">Photo ' + (index + 1) + ' of ' + items.length + '</span>';
      prev.disabled = index === 0;
      next.disabled = index === items.length - 1;
      // the photo shown and its neighbours load first
      [index - 1, index, index + 1].forEach(function (k) { var im = track.children[k] && qs('img', track.children[k]); if (im) im.loading = 'eager'; });
    }
    function go(i, instant) {
      if (i < 0 || i >= items.length) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'instant' : 'smooth' });
      setIndex(i);
    }
    function open(link) {
      var group = link.closest('[data-ivp-lbx-group]');
      var links = group ? qsa('[data-ivp-lbx]', group) : [link];
      if (!dlg) build();
      items = links.map(function (a) {
        var im = qs('img', a);
        return {
          src: a.getAttribute('href'), srcset: a.getAttribute('data-srcset') || '', alt: (im && im.alt) || '', caption: a.getAttribute('data-caption') || '',
          // the photo already on the page stands in (scaled up) until the large one arrives, so the stage is never blank
          thumb: im && im.complete && im.naturalWidth ? im.currentSrc || im.src : ''
        };
      });
      dlg.classList.toggle('ivp-lbx--light', !!group && group.getAttribute('data-ivp-lbx-tone') === 'light');
      dlg.classList.toggle('is-single', items.length < 2);
      dlg.setAttribute('aria-label', (group && group.getAttribute('data-ivp-lbx-group')) || 'Photo viewer');
      track.innerHTML = items.map(function (it) {
        return '<figure class="ivp-lbx__slide"><img src="' + esc(it.src) + '"' + (it.srcset ? ' srcset="' + esc(it.srcset) + '" sizes="100vw"' : '') +
          ' alt="' + esc(it.alt) + '" loading="lazy" decoding="async">' + (it.caption ? '<figcaption class="ivp-lbx__cap">' + esc(it.caption) + '</figcaption>' : '') + '</figure>';
      }).join('');
      items.forEach(function (it, k) {
        if (!it.thumb) return;
        var fig = track.children[k], big = qs('img', fig);
        fig.style.backgroundImage = 'url("' + it.thumb + '")';
        big.addEventListener('load', function () { fig.style.backgroundImage = 'none'; }, { once: true });
      });
      opener = link;
      dlg.showModal();
      lock();
      go(Math.max(0, links.indexOf(link)), true);
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ivp-lbx]');
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open(a);
    });
    M.lightbox = open;
  }

  function boot() {
    if (d.readyState === 'complete') detachLegacySearch(); else window.addEventListener('load', detachLegacySearch);
    initExpiry();
    initAnnouncement();
    initHeader();
    initMega();
    initSearch();
    initDrawers();
    initCart();
    initFooter();
    initScrollers();
    initSwipeBars();
    initTabs();
    initLazy();
    initFrames();
    initVideos();
    initCardHover();
    initReveal();
    initToTop();
    initSpots();
    initHeroVideo();
    initCardSwatches();
    initLightbox();
    initSafeLinks();
    dispatch('ivp:ready');
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
